import { BookSearch20Regular, Code20Regular, Savings20Regular } from '@/components/Icon'

/** @type {{ value: string, label: string, Icon: import('react').ComponentType }[]} */
export const HOME_AGENT_SELECT_OPTIONS = [
  { value: 'software-engineer', label: 'Software Engineering', Icon: Code20Regular },
  { value: 'financial-expert', label: 'Financial Analysis', Icon: Savings20Regular },
  { value: 'research-specialist', label: 'Research', Icon: BookSearch20Regular },
]
